export default __webpack_public_path__ + "assets/manager-testimonial-image-3.jpg";